/* eslint-disable react/prop-types */
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/macro';
import {
  Table,
  Button,
  Icon,
} from 'components/atoms';
import { Tooltip } from 'components/molecules'
import { injectIntl } from 'react-intl'
import { intlType } from 'types'

const PeopleTableSelect = memo(({
  data,
  loading,
  intl,
  noDataText,
  onSelect,
}) => {
  const handleSelect = (e, original) => {
    e.preventDefault()
    e.stopPropagation();
    onSelect(original)
  }

  return (
    <Table
      data={data}
      columns={[
        {
          Header: '',
          accessor: 'icon',
          resizable: false,
          width: 60,
          Cell: ({ original }) => (
            <Tooltip tooltip="selecionar pessoa" placement="top">
              <CellStart>
                <Button modifiers={['small', 'primaryHover']} onClick={(e) => handleSelect(e, original)}>
                  <Icon icon="fal fa-plus" height={16} />
                </Button>
              </CellStart>
            </Tooltip>
          ),
        },
        {
          Header: intl.formatMessage({ id: 'name' }),
          accessor: 'name',
          Cell: ({ value }) => (
            <Table.Cell
              value={value}
              loadingDots={loading}
            />
          ),
        },
        {
          Header: intl.formatMessage({ id: 'email' }),
          accessor: 'email',
          Cell: ({ value }) => (
            <Table.Cell
              value={value}
              loading={loading}
            />
          ),
        },
      ]}
      minRows={0}
      className="-striped -highlight"
      noDataText={loading ? '' : (noDataText || 'Não foram encontradas pessoas')}
      sortable={false}
      showPagination={false}
      loading={loading}
      loadingText="A carregar..."
    />
  )
});

const CellStart = styled.div`
  width: 100%;
`

PeopleTableSelect.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  loading: PropTypes.bool,
  intl: intlType.isRequired,
  noDataText: PropTypes.string,
};

PeopleTableSelect.defaultProps = {
  data: [],
  loading: true,
  noDataText: null,

}


export default injectIntl(PeopleTableSelect);
